import intersectionHelper from '../../../general/js/intersection-helper';
import BaseComponent from '../../../general/js/base-component';

export default class AboutStatisticsNumberComponent extends BaseComponent {
    constructor() {
        super(...arguments);

        let content = this.element.innerHTML;
        this.element.innerHTML = content.replace(/\d+,?\d*/, function (x) {   // wrap number to the <span> tag
            return '<span>' + x + '</span>';
        });

        //get first numerical value in the element content string
        let numericalValue = this.element.dataset.value.match(/\d+,?\d*/);
        if (!numericalValue) return;
        this.value = numericalValue[0];

        intersectionHelper.enterViewportOnce(this.element, this.init.bind(this));
    }

    init() {
        let currentValue = parseInt(this.value.replace(',', ''));
        let fromValue = Math.max(currentValue - 1, 0);
        let number = {value: fromValue};

        TweenLite.to(number, 1, {
            value: currentValue,
            onUpdate: () => {
                this.render(number.value);
            }
        });
    }

    render(value) {
        let stringValue = Math.floor(value).toString();
        if (stringValue.length > 3) {
            stringValue = stringValue.substr(0, stringValue.length - 3) + ',' + stringValue.substr(stringValue.length - 3, stringValue.length);
        }
        this.element.getElementsByTagName('SPAN')[0].innerHTML = stringValue;
    }
}



// WEBPACK FOOTER //
// ./app/components/about/js/about-statistics.component.js